import React from "react";
import { ConditionSelectProps } from "@sinch/components/application/RatelistBuilder/RateBuilderRowContent/ConditionInput/ConditionInput";
import { NumberInputBase } from "@sinch/components/form/NumberInputBase/NumberInputBase";

export const ConditionValueInputNumber = ({
  onChange,
  value,
  onBlur,
  onOpenChange,
  readOnly,
}: ConditionSelectProps<string>) => (
  <NumberInputBase
    allowEmpty
    fullWidth
    inputProps={{
      "data-cy": "ConditionInput-valueInput-number",
    }}
    onBlur={(e) => {
      onBlur?.(e);
    }}
    onChange={(e) => {
      const val = e.target.value;
      onChange?.(val);
    }}
    onFocus={() => onOpenChange(true)}
    readOnly={readOnly}
    sx={{ px: 1 }}
    value={value}
  />
);
